import { getQuestionType } from '@exam-management/common/utils';
import { Flex, ReadonlyField, SectionTitle } from '@shared/components';

import { QuestionReviewContentPreviewer } from '../../components';
import { useQuestionReviewTaskQuestionDetails } from '../../providers';

export default function QuestionParagraphView() {
  const { question, mainTaskDetails } = useQuestionReviewTaskQuestionDetails();
  const questionType = getQuestionType(question.questionGroup?.type);

  const questionGroupId = question.questionGroup?.id ?? '';
  const paragraph = question.questionGroup?.metadata?.paragraph ?? '';
  const taskId = mainTaskDetails.id;

  if (questionType === 'single') {
    return null;
  }

  return (
    <Flex sx={(theme) => ({ flexDirection: 'column', gap: theme.spacing(4) })}>
      <SectionTitle title='Paragraph' />
      <ReadonlyField
        content={
          <QuestionReviewContentPreviewer
            content={paragraph}
            questionGroupId={questionGroupId}
            taskId={taskId}
          />
        }
      />
    </Flex>
  );
}
